import { render, staticRenderFns } from "./FocusPointInput.vue?vue&type=template&id=64acc1ee&"
import script from "./FocusPointInput.vue?vue&type=script&lang=ts&"
export * from "./FocusPointInput.vue?vue&type=script&lang=ts&"
import style0 from "./FocusPointInput.vue?vue&type=style&index=0&id=64acc1ee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports